import React from "react";

import { FormikProps, FormikHelpers } from "formik";

import { PrescreeningForApplicants } from "manager/components/DealSetupSettings/ScreeningForApplicantsAndOccupants";
import { DealSetup } from "manager/interfaces/api";
import { FormPromptShell } from "shared/components/Form";
import { ViewOnlyBanner } from "shared/components/ViewOnlyBanner";
import { useConfigLock } from "shared/hooks/useConfigLock";

const INITIAL_VALUES = {};

interface PrescreeningSettingsProps {
  loading: boolean;
  dealSetup: DealSetup;
  saveChanges: (values: DealSetup) => void;
  onSubmit: (values: DealSetup, form: FormikHelpers<DealSetup>) => void;
  formRef: React.Ref<FormikProps<DealSetup>>;
  disabled: boolean;
  shouldDisableSubmitButton?: boolean;
  submitButtonLabel?: string;
  showSecondaryButton: boolean;
  onSecondaryButtonClick?: () => void;
  secondaryButtonLabel?: string;
  isVeroGoActive?: boolean;
}

const PrescreeningSettings = ({
  loading,
  dealSetup,
  saveChanges,
  onSubmit,
  formRef,
  disabled,
  shouldDisableSubmitButton = true,
  submitButtonLabel,
  showSecondaryButton,
  onSecondaryButtonClick,
  secondaryButtonLabel,
  isVeroGoActive,
}: PrescreeningSettingsProps) => {
  const { isLocked } = useConfigLock();
  const isDisabled = disabled || isLocked;

  const getPromptProps = ({ isValid }) => {
    return {
      title: "Unsaved changes",
      subtitle: isValid
        ? "Would you like to save the changes?"
        : "The changes you made are not valid and will not be saved.",
      submitButtonLabel: isValid ? "Yes" : "OK",
      cancelLinkLabel: isValid ? "No" : null,
    };
  };
  return (
    <>
      {isLocked && <ViewOnlyBanner />}
      <FormPromptShell
        initialValues={dealSetup || INITIAL_VALUES}
        onSubmit={onSubmit}
        submitButtonLabel={submitButtonLabel}
        shouldDisableSubmitButton={shouldDisableSubmitButton}
        saveChanges={saveChanges}
        formRef={formRef}
        getPromptProps={getPromptProps}
        showSecondaryButton={showSecondaryButton}
        onSecondaryButtonClick={onSecondaryButtonClick}
        secondaryButtonLabel={secondaryButtonLabel}
        showFooterWithSubmit={!isLocked}
      >
        <PrescreeningForApplicants loading={loading} disabled={isDisabled} isVeroGoActive={isVeroGoActive} />
      </FormPromptShell>
    </>
  );
};

export default PrescreeningSettings;
